import { render, staticRenderFns } from "./ClosedProject.vue?vue&type=template&id=6cecc46d&"
import script from "./ClosedProject.vue?vue&type=script&lang=js&"
export * from "./ClosedProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports